import styles from './index.module.scss'
import { Row, Col, Tag } from 'antd'
import { dealFileSize } from "@/utils/dealFileSize";
import intl from "react-intl-universal";
import { useNavigate } from "react-router-dom";

const InfoIntroduction = ({ info, firstType, secondType }) => {
	const navigate = useNavigate();

	const toLink = (id) => {
		navigate(`/user?uuid=${id}`);
		window.scrollTo(0, 0);
	}
	return (
		<div className={styles.infoIntroductionBox}>
			<h1>{info.title}</h1>
			<Row gutter={40}>
				<Col span={12}>
					<table>
						<tbody>
							<tr>
								<th>{intl.get("Share.Authors")}</th>
								<td>
									{info.author}
								</td>
							</tr>
							<tr>
								<th>{intl.get("Share.Contributor")}</th>
								<td onClick={() => toLink(info.contributorId)}>
									<a href="#">{info.contributor}</a>
								</td>
							</tr>

							{info.dataType && <tr>
								<th>{intl.get("Share.Date Type")}</th>
								<td><Tag color="cyan">{info.dataType}</Tag></td>
							</tr>}
							{
								(secondType !== "OpenDataServices" && secondType !== "OpenProcessServices" && secondType !== "OpenWebApps") &&
								<tr>
									<th>{intl.get("Share.Volumes")}</th>
									<td>{intl.get("Share.The size of this resource is")} {dealFileSize(info.Volumes)}</td>
								</tr>
							}
							<tr>
								<th>{intl.get("Share.Created")}</th>
								<td>{info.createTime}</td>
							</tr>
							<tr>
								<th>{intl.get("Share.Last updated")}</th>
								<td>{info.updateTime}</td>
							</tr>
							{
								info.dataSource && <tr>
									<th>{intl.get("Data Source")}</th>
									<td>
										{intl.get(info.dataSource)}
									</td>
								</tr>
							}
						</tbody>
					</table>
				</Col>
				<Col span={12}>
					<table>
						<tbody>
							{
								(secondType !== "OpenDataServices" && secondType !== "OpenProcessServices" && secondType !== "OpenWebApps") &&
								<tr>
									<th>{intl.get("Share.IsDownloadable")}</th>
									<td>{info.isDownloadable ? intl.get('true') : intl.get("false")}</td>
								</tr>
							}

							{
								(firstType === "OpenData" || firstType === "OpenTools") &&
								<tr>
									<th>{intl.get("Share.IsComputable")}</th>
									<td>{info.isComputable ? intl.get('true') : intl.get("false")}</td>
								</tr>
							}
							<tr>
								<th>{intl.get("Share.Views")}</th>
								<td>{info.viewTimes || 0}</td>
							</tr>
							<tr>
								<th>{intl.get("Share.Stars")}</th>
								<td>{info.collectTimes || 0}</td>
							</tr>

							{(secondType !== "OpenDataServices" && secondType !== "OpenProcessServices" && secondType !== "OpenWebApps") && <tr>
								<th>{intl.get("Share.Downloads")}</th>
								<td>{info.downloadTimes || 0}</td>
							</tr>
							}

							{
								(secondType !== "OpenDataServices" && secondType !== "OpenProcessServices" && secondType !== "OpenWebApps") && <tr>
									<th>{intl.get("Share.Content types")}</th>
									<td className={styles.contentTypes}>
										{info.contentTypes && info.contentTypes.map(item => {
											return <Tag key={item + "_tag"} color="magenta">{item}</Tag>
										})}
									</td>
								</tr>
							}
							{
								info.sampleType && <tr>
									<th>{intl.get("Sample Type")}</th>
									<td>
										{intl.get(info.sampleType)}
									</td>
								</tr>
							}
						</tbody>
					</table>
				</Col>
			</Row>
		</div>
	)
}
export default InfoIntroduction;